import React, { useState } from "react";

const SimpleToggleButton = ({
  checked,
  onChange,
  disabled = false,
  className = "",
}) => {
  const [toggleId] = useState(
    () => `toggle-${Math.random().toString(36).substr(2, 9)}`
  );

  const handleToggleClick = (e) => {
    if (disabled) return;
    e.preventDefault();
    e.stopPropagation();
    onChange(!checked);
  };

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      onChange(!checked);
    }
  };

  return (
    <div
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={handleToggleClick}
      onKeyDown={handleKeyDown}
      className={`relative inline-flex items-center cursor-pointer ${className} ${
        disabled ? "opacity-50 cursor-not-allowed" : "hover:opacity-90"
      }`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          e.stopPropagation();
          onChange(e.target.checked);
        }}
        disabled={disabled}
        className="sr-only peer"
        id={toggleId}
      />

      <div
        className={`w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer 
          peer-checked:after:translate-x-full peer-checked:after:border-white 
          after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
          after:bg-white after:border-gray-300 after:border after:rounded-full 
          after:h-5 after:w-5 after:transition-all peer-checked:bg-[#3538CD]
          ${disabled ? "cursor-not-allowed" : ""}`}
        aria-hidden="true"
      ></div>
      <label htmlFor={toggleId} className="sr-only">
        Toggle {checked ? "on" : "off"}
      </label>
    </div>
  );
};

export default SimpleToggleButton;
